import {
  ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, OnInit, Output,
} from '@angular/core';

@Component({
  selector: 'ut-user-tooltip',
  templateUrl: './user-tooltip.component.html',
  styleUrls: ['./user-tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UserTooltipComponent implements OnInit {
  @Input() user!: any;
  @Output() closeTooltip = new EventEmitter<void>();

  userRole: string = '';
  userLocation: string | null = null;

  constructor(
    @Inject('UserService') private UserService: any,
  ) {}

  ngOnInit(): void {
    if (this.user) {
      this.processUserData();
    }
  }

  private processUserData(): void {
    // Calculate points if not present
    if (!this.user.points) {
      this.user.points = !this.user.badges ? 0
        : this.user.badges.reduce((sum: number, badge: any) => sum + badge.points, 0);
    }

    // Get user role
    this.userRole = this.UserService.userRoleTitle(this.user);

    // Process user location
    this.userLocation = this.user.country?.name || null;
    const { state } = this.user;

    if (this.userLocation && state) {
      let countryAbbr: string | undefined;

      switch (this.userLocation) {
        case 'United States':
          countryAbbr = 'US';
          break;
        case 'Canada':
          countryAbbr = 'CA';
          break;
        default:
          break;
      }

      this.userLocation = state.name;
      if (countryAbbr) {
        this.userLocation += `, ${countryAbbr}`;
      }
    }
  }

  onCloseClick(event: Event): void {
    this.closeTooltip.emit();
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  onCloseKeyPress(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === 'Space' || event.key === ' ') {
      this.closeTooltip.emit();
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }

  onCloseFocus(event: FocusEvent): void {
    const target = event.target as HTMLElement;
    target.style.border = 'solid lightblue 1px';
  }

  onCloseBlur(event: FocusEvent): void {
    const target = event.target as HTMLElement;
    target.style.border = 'none';
  }
}
